import { useI18n } from '#imports';
import { createUseCheckout, getAuthCookie } from '@bubba/payments';

export function useCheckout(options: {
  orderId: string;
  returnUrl: string;
  onPaymentCompleted: (resultCode: string) => void;
  onPaymentFailed: (resultCode: string) => void;
  onError?: (error: Error) => void;
}) {
  const { $getLocale } = useI18n();
  const checkout = createUseCheckout({
    // Use the active app locale so checkout language matches the UI
    resolveLocale: () => $getLocale(),
    // Derive country code from browser locale (e.g. "en-US" → "US")
    resolveCountryCode: () => {
      if (typeof navigator !== 'undefined' && navigator.language) {
        const region = navigator.language.split('-')[1];
        if (region) return region.toUpperCase();
      }
      return 'US';
    },
    resolveAuthCookie: getAuthCookie,
    resolveReturnUrl: (url) => url!,
  });
  return checkout(options);
}
